import { t } from 'i18next'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import {
  TOKEN_FROM_EMAIL,
  VERIFY_FIRST_TIME_LOGIN,
  VERIFY_FORGOT_PASSWORD,
} from 'src/app/shared/constants/searchParams.constants'
import { ResetPasswordType } from 'src/app/shared/models/common.model'
import { verifyEmailToken } from 'src/app/shared/services/AuthenticationService'
import { logOutApp } from 'src/app/store'
import { lcStorageUserRole } from 'src/app/shared/constants/localStorage.constants'

const EmailRedirectGuard: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()
  const tokenFromEmail = useMemo(() => searchParams.get(TOKEN_FROM_EMAIL), [searchParams])

  const redirectToLoginWithErrorMessage = () => {
    navigate('/login', {
      state: {
        errorTitle: t('LoginPage:reset_password_link_expired_title'),
        errorMessage: t('LoginPage:reset_password_link_expired'),
      },
    })
  }

  useEffect(() => {
    if (String(pathname).includes(VERIFY_FIRST_TIME_LOGIN)) {
      sessionStorage.removeItem(lcStorageUserRole)
      dispatch(logOutApp())
      verifyEmailToken(pathname + search).then((res: any) => {
        if (res) {
          navigate('/reset-password', {
            state: {
              resetPasswordType: ResetPasswordType.FIRST_LOGIN,
              userName: res?.data?.userName || '',
            },
          })
        } else {
          redirectToLoginWithErrorMessage()
        }
      })
    }

    if (String(pathname).includes(VERIFY_FORGOT_PASSWORD)) {
      sessionStorage.removeItem(lcStorageUserRole)
      dispatch(logOutApp())
      verifyEmailToken(pathname + search)
        .then((res: any) => {
          if (res) {
            navigate('/reset-password', {
              state: {
                resetPasswordType: ResetPasswordType.FORGOT_PASSWORD,
                userName: res?.data?.userName || '',
              },
            })
          } else {
            redirectToLoginWithErrorMessage()
          }
        })
    }
  }, [navigate, pathname, search, tokenFromEmail])

  return null
}

export default EmailRedirectGuard
